import _isNil from "lodash/isNil";
import _trim from "lodash/trim";
import andExpression from './andExpression';
export default (condition, items, solution) => {
  return condition.split(' or ').map(_trim).map(exp => andExpression(exp, items, solution)).reduce((acc, _ref) => {
    let {
      item,
      result
    } = _ref;
    if (!_isNil(acc.item) && !_isNil(item) && acc.item !== item) {
      throw new Error("A condition should refer to only one item (".concat(acc.item.id, " and ").concat(item.id, " are used)"));
    }
    return {
      item: _isNil(item) ? acc.item : item,
      result: acc.result || result
    };
  }, {
    item: undefined,
    result: false
  });
};